import { render, staticRenderFns } from "./SnowInputFile.vue?vue&type=template&id=2c14e1ba&scoped=true&"
import script from "./SnowInputFile.vue?vue&type=script&lang=js&"
export * from "./SnowInputFile.vue?vue&type=script&lang=js&"
import style0 from "./SnowInputFile.vue?vue&type=style&index=0&id=2c14e1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14e1ba",
  null
  
)

export default component.exports